import * as PIXI from "pixi.js";
import {pixiComponents} from "../index";
import {spinStore, store} from "../store";
import {isMobile} from "pixi.js";
import {cpConfigs} from "./configs";
import {getAmountWithCurrency} from "../utilites";
import {CANVAS} from "../constants/configs";
import {t, TKeys} from "../translationService";

export const balanceTextInfo = {
    title: {
        get text() {
            return t(TKeys.BALANCE)
        },
        x: isMobile.phone ? 10 : 100,
        y: isMobile.phone ? cpConfigs.height - 90 : 2,
    },
    amount: spinStore.userBalance,
    fontSize: isMobile.phone ? 43 : 34,
};

export const betTextInfo = {
    title: {
        get text() {
            return t(TKeys.BET)
        },
        x: isMobile.phone ? 10 : 100,
        y: isMobile.phone ? cpConfigs.height - 50 : 38,
    },
    amount: spinStore.spinAmount,
    fontSize: isMobile.phone ? 43 : 34,
};

export const winTextInfo = {
    title: {
        get text() {
            return t(TKeys.WIN)
        },
        x: isMobile.phone ? 10 : 550,
        y: isMobile.phone ? cpConfigs.height - 128 : 20,
    },
    amount: spinStore.spinAmount,
    fontSize: isMobile.phone ? 50 : 60,
};

export const freeSpinsLeftInfo = {
    title: {
        get text() {
            return t("Free Spins Left")
        },
        x: isMobile.phone ? 10 : 550,
        y: isMobile.phone ? cpConfigs.height - 128 : 30,
    },
    amount: spinStore.spinAmount,
    fontSize: isMobile.phone ? 38 : 55,
};

export const freeSpinsLeftTextInfo = {
    y: isMobile.phone ? cpConfigs.height - 180 : 63,
    fontSize: isMobile.phone ? 39 : 35,
};

const addAmountInfoText = ({title, amount, fontSize}) => {
    const titleText = new PIXI.Text(`${title.text}`, {...amountTitleTextStyle, fontSize});
    titleText.x = title.x;
    titleText.y = title.y;
    pixiComponents.controlPanelContainer.addChild(titleText);

    const amountText = new PIXI.Text(getAmountWithCurrency(amount, store.currency), {...amountTextStyle, fontSize});
    amountText.x = titleText.x + titleText.width + 10;
    amountText.y = title.y;
    pixiComponents.controlPanelContainer.addChild(amountText);

    return {
        title: titleText,
        amount: amountText,
    };
};

export const addBalanceInfoText = () => addAmountInfoText(balanceTextInfo);

export const addBetAmountInfoText = () => addAmountInfoText(betTextInfo);

export const addWinAmountInfoText = () => {
    const {title, amount, fontSize} = winTextInfo;
    const container = new PIXI.Container();
    const titleText = new PIXI.Text(`${title.text}`, {...amountTitleTextStyle, fontSize});
    container.addChild(titleText);

    const amountText = new PIXI.Text(getAmountWithCurrency(amount * 1000, store.currency), {
        ...amountTextStyle,
        fontSize
    });
    amountText.x = titleText.width + 10;
    container.addChild(amountText);

    pixiComponents.controlPanelContainer.addChild(container);
    container.pivot.set(container.width / 2, container.height / 2);
    container.x = CANVAS.width / 2;
    container.y = title.y;

    return {
        title: titleText,
        amount: amountText,
        container
    };
};

export const addFreeSpinLeftInfoText = () => {
    const {title, amount, fontSize} = freeSpinsLeftInfo;
    const container = new PIXI.Container();
    const titleText = new PIXI.Text(`${title.text} `, {...amountTextStyle, fontSize});
    container.addChild(titleText);

    const amountText = new PIXI.Text('8', {...amountTextStyle, fontSize});
    amountText.x = titleText.width + 10;
    amountText.updatePos = () => amountText.x = titleText.width + 10;
    container.addChild(amountText);

    pixiComponents.controlPanelContainer.addChild(container);
    container.pivot.set(container.width/2, container.height/2);
    container.x = CANVAS.width/2;
    container.y = title.y;

    return {
        title: titleText,
        amount: amountText,
        container
    };
};

export const addFreeSinsLeftInfoText = () => {
    const {y, fontSize} = freeSpinsLeftTextInfo;
    const text = new PIXI.Text("FREE SPINS LEFT 8", {...amountTextStyle, fontSize});
    text.anchor.set(0.5);
    text.position.set(CANVAS.width/2, y);

    pixiComponents.controlPanelContainer.addChild(text);
    return text;
};

const amountTitleTextStyle = new PIXI.TextStyle({
    fontFamily: 'BebasNeue',
    fontWeight: 500,
    fill: ['#f5c013', '#f59b13'],
    dropShadow: true,
    dropShadowColor: 'rgba(0,0,0,0.68)',
    dropShadowBlur: 4,
    dropShadowAngle: Math.PI / 4,
    dropShadowDistance: 2,
});

const amountTextStyle = new PIXI.TextStyle({
    fontFamily: 'BebasNeue',
    fontWeight: 500,
    fill: ['#ffffff', '#c0c0c0'],
    dropShadow: true,
    dropShadowColor: 'rgba(0,0,0,0.68)',
    dropShadowBlur: 4,
    dropShadowAngle: Math.PI / 4,
    dropShadowDistance: 1,
});

export const showFreeSinsLeftInfoText = (quantity) => {
    pixiComponents.cpItems.freeSinsLeftText.text = `${t(TKeys.FREE_SPINS_LEFT)} ${quantity}`;
    pixiComponents.cpItems.freeSinsLeftText.visible = true;
}

export const hideFreeSinsLeftInfoText = () => pixiComponents.cpItems.freeSinsLeftText.visible = false;